import { createAction, props } from '@ngrx/store';
import { Product } from '@uc/shared/data-models';
import {
	ClearingCourse,
	Course,
	UniversityClearingCourse,
	UniversityCourse,
} from '../../models/course.models';

export const fetchCourse = createAction(
	'[StateCourse/API] Fetch Course',
	props<{ courseSlug: string }>(),
);

export const updateCourse = createAction(
	'[StateCourse/API] Update Course',
	props<{ course: Course | null }>(),
);

export const fetchUniversity = createAction(
	'[StateCourse/API] Fetch University',
	props<{ uniSlug: string; product?: Product }>(),
);

export const updateUniversity = createAction(
	'[StateCourse/API] Update University',
	props<{ university: UniversityCourse | null }>(),
);

export const fetchClearingCourse = createAction(
	'[StateCourse/API] Fetch Clearing Course',
	props<{ courseSlug: string }>(),
);

export const updateClearingCourse = createAction(
	'[StateCourse/API] Update Clearing Course',
	props<{ clearingCourse: ClearingCourse | null }>(),
);

export const fetchClearingUniversity = createAction(
	'[StateCourse/API] Fetch Clearing University',
	props<{ uniSlug: string; product?: Product }>(),
);

export const updateClearingUniversity = createAction(
	'[StateCourse/API] Update Clearing University',
	props<{ clearingUniversity: UniversityClearingCourse | null }>(),
);

export const loadStateCourseFailure = createAction(
	'[StateCourse/API] Load State Course Failure',
	props<any>(),
);
